import { render, staticRenderFns } from "./TemplatesSection.vue?vue&type=template&id=74d54651&scoped=true"
import script from "./TemplatesSection.vue?vue&type=script&lang=js"
export * from "./TemplatesSection.vue?vue&type=script&lang=js"
import style0 from "./TemplatesSection.vue?vue&type=style&index=0&id=74d54651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d54651",
  null
  
)

export default component.exports